import { FunctionComponent, useMemo } from 'react';
import { getDuration } from '../../../../../services/getDuration';

type CourseDurationLabelProps = {
    courseDuration: number;
    isOnDemand: boolean;
};

export const CourseDurationLabel: FunctionComponent<CourseDurationLabelProps> = ({
    courseDuration,
    isOnDemand,
}) => {
    const courseDurationLabel = useMemo(() => {
        return getDuration(courseDuration, isOnDemand);
    }, [courseDuration, isOnDemand]);

    return <p>{courseDurationLabel}</p>;
};
